/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import React from 'react';

import {OverviewBuyBox, OverviewPeriodRange} from '../../../../util/interfaces';

import {getOverviewBuyBox} from '../../../../util/requestSender';

import {useOverviewSection} from '../useOverviewSection';

import BuyBox from './buyBox';

interface Props {
    accountIds: Array<string>;
    period: OverviewPeriodRange;
}

export default function BuyBoxController({accountIds, period}: Props) {
    const section = useOverviewSection<OverviewBuyBox>({request: getOverviewBuyBox, accountIds, period});

    return <BuyBox {...section} />;
}
